$dependencyManager.addDependencyCallback('swiper', () => {
    class Image2Slider {
        constructor(container) {
            this.container = jQuery(container);
            this.slider = this.container.find('> .mad-slider');
            this.sliderId = this.container.data('slider-id');
            this.autoplay = this.container.data('autoplay');
            this.autoplayDelay = parseInt(this.container.data('autoplay-delay'), 10);
            this.loop = this.slider.data('loop') == true;
            this.displayPagination = jQuery(`.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__pagination`).length > 0;
            this.swiper = null;

            // Initialize slider
            this.initSlider();

            this.container.css('opacity', '1');
        }

        initSlider() {
            this.swiper = new Swiper(`.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__slides-container`, {
                slidesPerView: 1,
                centeredSlides: true,
                loop: this.loop,
                slideClass: 'mad-slider__slide',
                wrapperClass: 'mad-slider__slides',
                navigation: {
                    nextEl: `.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__button-next`,
                    prevEl: `.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__button-prev`,
                },
                pagination: this.displayPagination ? {
                    el: `.mad-slider__container[data-slider-id="${this.sliderId}"] .mad-slider__pagination`,
                    clickable: true,
                } : false,
                updateOnWindowResize: true,

                autoplay: this.autoplay ? {
                    delay: this.autoplayDelay,
                    disableOnInteraction: true,
                } : false,
                
                on: {
                    init: function() {
                        // this.update();
                    },
                    slideChange: function() {
                    },
                    resize: function() {
                    }
                },
                breakpoints: {
                    768: {
                        slidesPerView: 'auto',
                    },
                },
            });
            
            // this.swiper.update();
            
            // window.addEventListener('resize', () => {
            //     if (this.swiper) {
            //         this.swiper.update();
            //     }
            // });
        }
    }

    jQuery('.mad-slider__container--image2').each(function() {
        new Image2Slider(this);
    });
});
